import React from 'react'
import './features.css'
import { Feature } from '../../components'

const featuresData=[
  {
  title:'Advanced analytics',
  text:' Utilizing satellite data and advanced analytics, our data-driven waste collection system optimizes routes in real-time, reducing fuel consumption and costs.'
},
  {
  title:'Social Impact',
  text:'By improving recycling rates and reducing contamination, we decrease landfill waste and contribute to environmental sustainability. Optimized waste collection routes lower fuel consumption and greenhouse gas emissions, reducing our carbon footprint.'
},
  {
  title:'Municipality cost saving',
  text:' Our efficient waste management solutions help municipalities save on operational costs, allowing them to allocate resources to other critical areas.'

},
  {
  title:'Job creation',
  text:'The implementation and maintenance of advanced waste management technologies create job opportunities within communities.'
},
]
const Features = () => {
  return (
    <div className='yellow__features section__padding' id='features'>
      <div className='yellow__features-heading'>
        <h1 className='gradient__text'>The imperative for data-driven recycling and waste management technology is clear.</h1>
        <p>The imperative for data-driven recycling</p>
      </div>
      <div className='yellow__features-container'>
        {featuresData.map((item, index)=>(
          <Feature title={item.title} text={item.text} key={item.title + index}/>
        ))}
      </div>

    </div>
  )
}

export default Features